export const state = {
    cnaeTemServicos: false,
}

export const mutations = {
    SET_CNAE_TEM_SERVICOS: (state, valor) => {
        state.cnaeTemServicos = valor
    },
}

export const getters = {
    cnaeTemServicos(state) {
        return state.cnaeTemServicos;
    },
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    /*
    init({state, dispatch}) {
        dispatch('validate')
    },*/

    cnaeTemServicos({commit}, valor) {
        commit('SET_CNAE_TEM_SERVICOS', valor);
    },

}
